import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Payout/refund screens only make sense when the parent organisation is a fleet owner.
 * Drivers invited by an accounting firm are sent back to their receipts.
 */
export const PayoutsOnly = ({ children }) => {
  const { isAccountingFirm, loading } = useAuth();
  if (loading) return null;
  if (isAccountingFirm) return <Navigate to="/me/receipts" replace />;
  return children;
};

export default PayoutsOnly;
